import { render, staticRenderFns } from "./ImageCard2.vue?vue&type=template&id=2c15e19c&"
import script from "./ImageCard2.vue?vue&type=script&lang=js&"
export * from "./ImageCard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports